import { makeAutoObservable, observable, toJS } from "mobx";
import ConversionStatisticsStore from "./ConversionStatisticsStore";
import NumberOfCasesStore from "./NumberOfCasesStore";
import TimeSpentStore from "./TimeSpentStore";
import WorkflowStore from "./WorkflowStore";
import GoalsStore from "./GoalsStore";

class ToolStore {
  isAuthenticated = null;
  selectedItem = null;
  initialValues = null;
  defaultTemplate = { key: -1 };
  user = null;
  numbersToTest = {
    w24: 0,
    w25: 0,
    w28: 0,
    w29: 0,
  };
  symbol = "$";
  conditions = {
    separateTeensAdults: false,
    showHourly: false,
    separateStaffRole: false,
    smileMate: false,
    monitoringAligners: false,
    monitoringBraces: false,
  };

  reset() {
    this.selectedItem = null;
    this.defaultTemplate = { key: -1 };
    this.numbersToTest = {
      w24: 0,
      w25: 0,
      w28: 0,
      w29: 0,
    };
    this.isAuthenticated = null;
    this.symbol = "$";
    this.conditions = {
      separateTeensAdults: false,
      showHourly: false,
      separateStaffRole: false,
      smileMate: false,
      monitoringAligners: false,
      monitoringBraces: false,
    };
  }
  constructor() {
    makeAutoObservable(this, {
      selectedItem: observable,
      isAuthenticated: observable,
      user: observable,
    });
  }
  setUser(val) {
    this.user = val;
  }
  setIsAuthenticated(val) {
    this.isAuthenticated = val;
  }
  setCurrencySymbol(symbol) {
    this.symbol = symbol;
  }
  setTemplates(data) {
    this.templates = data;
  }
  setInitialValues(data) {
    this.initialValues = data;
  }
  setSelectedItem(data) {
    this.setNumbersToTest(data);
    this.selectedItem = data;
    if (this.defaultTemplate.key != data.key) {
      this.defaultTemplate = data;
    }
    this.symbol = data.symbol;

    this.toChangeConditions();
    //this.onChangePracticeProfileData(data.practiceProfile);
    NumberOfCasesStore.setData(data.numberOfCases);
    ConversionStatisticsStore.setData(data.conversionStatistics);
    TimeSpentStore.setData(data.timeSpentOnTheExam);
    WorkflowStore.setData(data.workflowTreatement);
    GoalsStore.setData(data.goalsAndObjectives);
  }
  setNumbersToTest(data) {
    var w24 = 0;
    var w25 = 0;
    var w28 = 0;
    var w29 = 0;

    data.numberOfCases[0].value
      .filter((e) => e.fieldName == "general")[0]
      .value.filter((x) => {
        if (x.fieldName == "newAlignersTreatement") {
          w24 = x.value[0].value;
          w25 = x.value[1].value;
        }
        if (x.fieldName == "newBraces") {
          w28 = x.value[0].value;
          w29 = x.value[1].value;
        }
      });

    this.numbersToTest = {
      w24: parseFloat(w24) || 0,
      w25: parseFloat(w25) || 0,
      w28: parseFloat(w28) || 0,
      w29: parseFloat(w29) || 0,
    };
  }
  toChangeConditions = () => {
    var newSeparateTeensAdults = true;
    var selected = toJS(this.selectedItem);
    selected.practiceProfile[0].value.forEach((element) => {
      if (element.fieldName == "separateTeensAdults") {
        newSeparateTeensAdults = element.value;
      }
    });

    var newSeparateStaffRole = true;
    selected.practiceProfile[0].value.forEach((element) => {
      if (element.fieldName == "separateRole") {
        newSeparateStaffRole = element.value;
      }
    });
    var newChangeShowHourly = true;
    selected.practiceProfile[0].value.forEach((element) => {
      if (element.fieldName == "showHourly") {
        newChangeShowHourly = element.value;
      }
    });

    var newSmileMate = true;
    var newMonitoringAligners = true;
    var newMonitoringBraces = true;
    selected.practiceProfile[0].value.forEach((element) => {
      if (element.fieldName == "products") {
        element.value.forEach((x) => {
          if (x.fieldName == "SmileMateFor") {
            newSmileMate = x.value;
          }
          if (x.fieldName == "monitoringFor") {
            newMonitoringAligners = x.value;
          }
          if (x.fieldName == "bracesFor") {
            newMonitoringBraces = x.value;
          }
        });
      }
    });

    var c = {};
    c.separateStaffRole = newSeparateStaffRole;

    c.separateTeensAdults = newSeparateTeensAdults;
    c.showHourly = newChangeShowHourly;
    c.smileMate = newSmileMate;
    c.monitoringAligners = newMonitoringAligners;
    c.monitoringBraces = newMonitoringBraces;
    this.conditions = c;
  };

  setConditons(values) {
    this.conditions = values;
  }

  toChangeSeparateTeens(newValue) {
    var c = { ...this.conditions };
    const defaultSelected = { ...toJS(this.defaultTemplate) };
    const changedValues = { ...toJS(NumberOfCasesStore.changed) };
    const changedValuesWork = { ...toJS(WorkflowStore.changed) };

    c.separateTeensAdults = newValue;
    const selected = { ...this.selectedItem };
    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "general")[0]
      .value.forEach((x) => {
        //# New Aligners treatment starts/ year

        if (x.fieldName == "newAlignersTreatement") {
          if (newValue) {
            x.display = true && c.monitoringAligners;

            if (x.value[0].display != -1) {
              x.value[0].display = true && c.monitoringAligners;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.monitoringAligners;
            }

            var newAlignersTreatementDefault =
              defaultSelected.numberOfCases[0].value
                .filter((i) => i.fieldName == "general")[0]
                .value.filter(
                  (j) => j.fieldName == "newAlignersTreatement",
                )[0].value;
            x.value[0].value = newAlignersTreatementDefault[0].value;
            x.value[1].value = newAlignersTreatementDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValues[
              "newAlignersTreatement" + x.value[0].fieldName
            ] = false;
            changedValues[
              "newAlignersTreatement" + x.value[1].fieldName
            ] = false;
          } else {
            x.display = false;
            x.value[1].value = 0;
            if (x.value[0].display != -1) {
              x.value[1].display = false;
            }
          }
        }
        //# New Braces treatment starts/ year
        if (x.fieldName == "newBraces") {
          if (newValue) {
            x.display = true && c.monitoringBraces;
            if (x.value[0].display != -1) {
              x.value[0].display = true && c.monitoringBraces;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.monitoringBraces;
            }
            var newBracesDefault = defaultSelected.numberOfCases[0].value
              .filter((i) => i.fieldName == "general")[0]
              .value.filter((j) => j.fieldName == "newBraces")[0].value;
            x.value[0].value = newBracesDefault[0].value;
            x.value[1].value = newBracesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
            x.value[1].value = 0;
          }
        }
      });

    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "alignersCases")[0]
      .value.forEach((x) => {
        //Average price of the aligner treatment to the patient

        if (x.fieldName == "averagePrice") {
          if (newValue) {
            if (x.value[0].display != -1) {
              x.display = 1 && c.monitoringAligners;
              x.value[0].display = true && c.monitoringAligners;
            }
            x.value[0].fieldName = "adults";
            if (x.value[1].display != -1) {
              x.value[1].display = 1 && c.monitoringAligners;
            }

            var averagePricesDefault = defaultSelected.numberOfCases[0].value
              .filter((i) => i.fieldName == "alignersCases")[0]
              .value.filter((j) => j.fieldName == "averagePrice")[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValues["averagePrice" + x.value[0].fieldName] = false;

            changedValues["averagePrice" + x.value[1].fieldName] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
        //Add'l fee for Aligners Retention post-treatment ?
        if (x.fieldName == "addFeeAligners") {
          if (newValue) {
            x.display = true && c.monitoringBraces;
            if (x.value[0].display != -1) {
              x.value[0].display = true && c.monitoringBraces;
            }
            x.value[0].fieldName = "adults";
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.monitoringBraces;
            }

            var averagePricesDefault = defaultSelected.numberOfCases[0].value
              .filter((i) => i.fieldName == "alignersCases")[0]
              .value.filter((j) => j.fieldName == "addFeeAligners")[0].value;

            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
      });
    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "bracesCases")[0]
      .value.forEach((x) => {
        if (x.fieldName == "averagePriceBraces") {
          if (newValue) {
            x.display = true && c.monitoringBraces;
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault = defaultSelected.numberOfCases[0].value
              .filter((i) => i.fieldName == "bracesCases")[0]
              .value.filter(
                (j) => j.fieldName == "averagePriceBraces",
              )[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValues["averagePriceBraces" + x.value[0].fieldName] = false;
            changedValues["averagePriceBraces" + x.value[1].fieldName] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
        if (x.fieldName == "addFeeBraces") {
          if (newValue) {
            x.display = true && c.monitoringBraces;
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }

            var averagePricesDefault = defaultSelected.numberOfCases[0].value
              .filter((i) => i.fieldName == "bracesCases")[0]
              .value.filter((j) => j.fieldName == "addFeeBraces")[0].value;

            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValues["addFeeBraces" + x.value[0].fieldName] = false;
            changedValues["addFeeBraces" + x.value[1].fieldName] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
      });

    //workflowTreatment
    //alignersStatistics
    selected.workflowTreatement[0].value
      .filter((a) => a.fieldName == "alignersStatistics")[0]
      .value.forEach((x) => {
        if (x.fieldName == "averageDuration") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[0].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "alignersStatistics")[0]
                .value.filter((j) => j.fieldName == "averageDuration")[0].value;
            if (x.value[0].display != -1) {
              x.value[0].value = averagePricesDefault[0].value;
              x.value[0].changed = false;
            }
            if (x.value[1].display != -1) {
              x.value[1].value = averagePricesDefault[1].value;
              x.value[1].changed = false;
            }

            changedValuesWork[
              "alignersStatisticsaverageDurationadults"
            ] = false;
            changedValuesWork["alignersStatisticsaverageDurationteens"] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
        if (x.fieldName == "appointmentsOverTreatment") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "alignersStatistics")[0]
                .value.filter(
                  (j) => j.fieldName == "appointmentsOverTreatment",
                )[0].value;
            if (x.value[0].display != -1) {
              x.value[0].value = averagePricesDefault[0].value;
              x.value[0].changed = false;
            }
            if (x.value[0].display != -1) {
              x.value[1].value = averagePricesDefault[1].value;
              x.value[1].changed = false;
            }

            changedValuesWork[
              "alignersStatisticsappointmentsOverTreatmentadults"
            ] = false;
            changedValuesWork[
              "alignersStatisticsappointmentsOverTreatmentteens"
            ] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
        if (x.fieldName == "appointementRefinement") {
          if (newValue) {
            x.display = true && c.monitoringBraces;
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[0].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "alignersStatistics")[0]
                .value.filter(
                  (j) => j.fieldName == "appointementRefinement",
                )[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValuesWork[
              "alignersStatisticsappointementRefinementadults"
            ] = false;
            changedValuesWork[
              "alignersStatisticsappointementRefinementteens"
            ] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }

        if (x.fieldName == "emergencyAppointments") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "alignersStatistics")[0]
                .value.filter(
                  (j) => j.fieldName == "emergencyAppointments",
                )[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValuesWork[
              "alignersStatisticsemergencyAppointmentsadults"
            ] = false;
            changedValuesWork[
              "alignersStatisticsemergencyAppointmentsteens"
            ] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
      });

    //workflowTreatment
    //bracesStatistics
    selected.workflowTreatement[0].value
      .filter((a) => a.fieldName == "bracesStatistics")[0]
      .value.forEach((x) => {
        if (x.fieldName == "bracesAverageDuration") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "bracesStatistics")[0]
                .value.filter(
                  (j) => j.fieldName == "bracesAverageDuration",
                )[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValuesWork[
              "bracesStatisticsbracesAverageDurationadults"
            ] = false;
            changedValuesWork[
              "bracesStatisticsbracesAverageDurationteens"
            ] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
        if (x.fieldName == "bracesAppointmentsOverTreatment") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "bracesStatistics")[0]
                .value.filter(
                  (j) => j.fieldName == "bracesAppointmentsOverTreatment",
                )[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValuesWork[
              "bracesStatisticsbracesAppointmentsOverTreatmentadults"
            ] = false;
            changedValuesWork[
              "bracesStatisticsbracesAppointmentsOverTreatmentteens"
            ] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }

        if (x.fieldName == "bracesInaddition") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "bracesStatistics")[0]
                .value.filter(
                  (j) => j.fieldName == "bracesInaddition",
                )[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValuesWork["bracesStatisticsbracesInadditionadults"] = false;
            changedValuesWork["bracesStatisticsbracesInadditionteens"] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
      });
    //workflowTreatment
    //relapse
    selected.workflowTreatement[0].value
      .filter((a) => a.fieldName == "relapse")[0]
      .value.forEach((x) => {
        if (x.fieldName == "averageRelapse") {
          if (newValue) {
            if (x.display != -1) {
              x.display = true && c.monitoringBraces;
            }
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }
            var averagePricesDefault =
              defaultSelected.workflowTreatement[0].value
                .filter((i) => i.fieldName == "relapse")[0]
                .value.filter((j) => j.fieldName == "averageRelapse")[0].value;
            x.value[0].value = averagePricesDefault[0].value;
            x.value[1].value = averagePricesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValuesWork["relapsebracesaverageRelapseadults"] = false;
            changedValuesWork["relapsebracesaverageRelapseteens"] = false;
          } else {
            x.display = false;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
          }
        }
      });

    NumberOfCasesStore.setChanged(changedValues);
    WorkflowStore.setChanged(changedValuesWork);

    this.setSelectedItem(selected);
    this.setConditons(c);
  }
  toChangeSeparateRole(newValue) {
    var c = { ...this.conditions };
    c.separateStaffRole = newValue;

    const defaultSelected = { ...toJS(this.defaultTemplate) };
    const changedValuesTimeSpent = { ...toJS(TimeSpentStore.changed) };

    const selected = { ...this.selectedItem };
    if (newValue) {
      var x = toJS(
        selected.timeSpentOnTheExam[0].value.filter(
          (e) => e.fieldName == "staffTimeSpent",
        )[0],
      );

      var stafCostHourDefault =
        defaultSelected.timeSpentOnTheExam[0].value.filter(
          (i) => i.fieldName == "staffTimeSpent",
        );

      selected.timeSpentOnTheExam[0].value.filter(
        (e) => e.fieldName == "staffTimeSpent",
      )[0].value[0].value = stafCostHourDefault[0].value[0].value;
      selected.timeSpentOnTheExam[0].value.filter(
        (e) => e.fieldName == "staffTimeSpent",
      )[0].value[1].value = stafCostHourDefault[0].value[1].value;
      selected.timeSpentOnTheExam[0].value.filter(
        (e) => e.fieldName == "staffTimeSpent",
      )[0].value[2].value = stafCostHourDefault[0].value[2].value;

      selected.timeSpentOnTheExam[0].value.filter(
        (e) => e.fieldName == "staffTimeSpent",
      )[0].value[0].changed = false;
      selected.timeSpentOnTheExam[0].value.filter(
        (e) => e.fieldName == "staffTimeSpent",
      )[0].value[1].changed = false;
      selected.timeSpentOnTheExam[0].value.filter(
        (e) => e.fieldName == "staffTimeSpent",
      )[0].value[2].changed = false;

      changedValuesTimeSpent["staffTimeSpentdentalAssistant"] = false;
      changedValuesTimeSpent["staffTimeSpenttreatmentCoordinator"] = false;
      changedValuesTimeSpent["staffTimeSpentfrontDesk"] = false;
    }

    TimeSpentStore.setChanged(changedValuesTimeSpent);
    this.setSelectedItem(selected);

    this.setConditons(c);
  }
  toChangeShowHourly(newValue) {
    var c = { ...this.conditions };
    const defaultSelected = { ...toJS(this.defaultTemplate) };
    const changedValuesNbCases = { ...toJS(NumberOfCasesStore.changed) };

    c.showHourly = newValue;
    const selected = { ...toJS(this.selectedItem) };

    selected.numberOfCases[0].value
      .filter((e) => e.fieldName == "cost")[0]
      .value.filter((x) => {
        if (x.fieldName == "stafCostHour" && newValue) {
          var stafCostHourDefault = defaultSelected.numberOfCases[0].value
            .filter((i) => i.fieldName == "cost")[0]
            .value.filter((z) => z.fieldName == "stafCostHour");
          x.value[0].value = stafCostHourDefault[0].value[0].value;
          x.value[1].value = stafCostHourDefault[0].value[1].value;
          x.value[2].value = stafCostHourDefault[0].value[2].value;
          x.value[0].changed = false;
          x.value[1].changed = false;
          x.value[2].changed = false;
          changedValuesNbCases["stafCostHourdentalAssistant"] = false;
          changedValuesNbCases["stafCostHourtreatmentCoordinator"] = false;
          changedValuesNbCases["stafCostHourfrontDesk"] = false;
        }
        if (x.fieldName == "doctorCostHour" && newValue) {
          var stafCostHourDefault = defaultSelected.numberOfCases[0].value
            .filter((i) => i.fieldName == "cost")[0]
            .value.filter((z) => z.fieldName == "doctorCostHour");

          x.value = stafCostHourDefault[0].value;
          x.changed = false;
          changedValuesNbCases["doctorCostHour"] = false;
        }
      });
    NumberOfCasesStore.setChanged(changedValuesNbCases);
    this.setSelectedItem(selected);

    this.setConditons(c);
  }

  onCheckSmileMate(newValue) {
    var c = { ...this.conditions };
    c.smileMate = newValue;
    this.setConditons(c);
  }

  onCheckMonitoringAligners(newValue) {
    var c = { ...this.conditions };
    c.monitoringAligners = newValue;
    const selected = { ...this.selectedItem };
    const defaultSelected = { ...toJS(this.defaultTemplate) };
    const changedValues = { ...toJS(NumberOfCasesStore.changed) };
    //# New Aligners treatment starts/ year

    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "general")[0]
      .value.forEach((x) => {
        if (x.fieldName == "newAlignersTreatement") {
          if (newValue) {
            x.display = true;
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }

            var newAlignersTreatementDefault =
              defaultSelected.numberOfCases[0].value
                .filter((i) => i.fieldName == "general")[0]
                .value.filter(
                  (j) => j.fieldName == "newAlignersTreatement",
                )[0].value;
            x.value[0].value = newAlignersTreatementDefault[0].value;
            x.value[1].value = newAlignersTreatementDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;

            changedValues[
              "newAlignersTreatement" + x.value[0].fieldName
            ] = false;
            changedValues[
              "newAlignersTreatement" + x.value[1].fieldName
            ] = false;
          } else {
            x.display = false;
            if (x.value[0].display != -1) {
              x.value[0].display = false;
            }
            x.value[0].value = 0;
            if (x.value[0].display != -1) {
              x.value[1].display = false;
            }
            x.value[1].value = 0;
          }
        }
      });

    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "alignersCases")[0]
      .value.forEach((x) => {
        if (x.fieldName == "averagePrice" && newValue) {
          x.display = true;
          if (x.value[0].display != -1) {
            x.value[0].display = true;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = true && c.separateTeensAdults;
          }

          var averagePricesDefault = defaultSelected.numberOfCases[0].value
            .filter((i) => i.fieldName == "alignersCases")[0]
            .value.filter((j) => j.fieldName == "averagePrice")[0].value;
          x.value[0].value = averagePricesDefault[0].value;
          x.value[1].value = averagePricesDefault[1].value;

          x.value[0].changed = false;
          x.value[1].changed = false;

          changedValues["averagePrice" + x.value[0].fieldName] = false;

          changedValues["averagePrice" + x.value[1].fieldName] = false;
        }
        if (x.fieldName == "addFeeAligners" && newValue) {
          x.display = true;
          if (x.value[0].display != -1) {
            x.value[0].display = true;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = true && c.separateTeensAdults;
          }

          var averagePricesDefault = defaultSelected.numberOfCases[0].value
            .filter((i) => i.fieldName == "alignersCases")[0]
            .value.filter((j) => j.fieldName == "addFeeAligners")[0].value;

          x.value[0].value = averagePricesDefault[0].value;
          x.value[1].value = averagePricesDefault[1].value;

          changedValues["addFeeAligners" + x.value[0].fieldName] = false;
          changedValues["addFeeAligners" + x.value[1].fieldName] = false;
        }
      });
    NumberOfCasesStore.setChanged(changedValues);
    this.setSelectedItem(selected);
    this.setConditons(c);
  }

  onCheckMonitoringbraces(newValue) {
    var c = { ...this.conditions };
    const defaultSelected = { ...toJS(this.defaultTemplate) };
    const changedValues = { ...toJS(NumberOfCasesStore.changed) };

    c.monitoringBraces = newValue;
    const selected = { ...this.selectedItem };
    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "general")[0]
      .value.forEach((x) => {
        if (x.fieldName == "newBraces") {
          if (newValue) {
            x.display = true;
            if (x.value[0].display != -1) {
              x.value[0].display = true;
            }
            if (x.value[1].display != -1) {
              x.value[1].display = true && c.separateTeensAdults;
            }

            var newBracesDefault = defaultSelected.numberOfCases[0].value
              .filter((i) => i.fieldName == "general")[0]
              .value.filter((j) => j.fieldName == "newBraces")[0].value;
            x.value[0].value = newBracesDefault[0].value;
            x.value[1].value = newBracesDefault[1].value;
            x.value[0].changed = false;
            x.value[1].changed = false;
            changedValues["newBraces" + x.value[0].fieldName] = false;
            changedValues["newBraces" + x.value[1].fieldName] = false;
          } else {
            x.display = false;
            if (x.value[0].display != -1) {
              x.value[0].display = false;
            }
            x.value[0].value = 0;
            if (x.value[1].display != -1) {
              x.value[1].display = false;
            }
            x.value[1].value = 0;
          }
        }
      });

    selected.numberOfCases[0].value
      .filter((a) => a.fieldName == "bracesCases")[0]
      .value.forEach((x) => {
        if (x.fieldName == "averagePriceBraces" && newValue) {
          x.display = true;
          if (x.value[0].display != -1) {
            x.value[0].display = true;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = true && c.separateTeensAdults;
          }
          var averagePricesDefault = defaultSelected.numberOfCases[0].value
            .filter((i) => i.fieldName == "bracesCases")[0]
            .value.filter((j) => j.fieldName == "averagePriceBraces")[0].value;
          x.value[0].value = averagePricesDefault[0].value;
          x.value[1].value = averagePricesDefault[1].value;

          x.value[0].changed = false;
          x.value[1].changed = false;

          changedValues["averagePriceBraces" + x.value[0].fieldName] = false;
          changedValues["averagePriceBraces" + x.value[1].fieldName] = false;
        }
        if (x.fieldName == "addFeeBraces" && newValue) {
          x.display = true;
          if (x.value[0].display != -1) {
            x.value[0].display = true;
          }
          if (x.value[1].display != -1) {
            x.value[1].display = true && c.separateTeensAdults;
          }

          var averagePricesDefault = defaultSelected.numberOfCases[0].value
            .filter((i) => i.fieldName == "bracesCases")[0]
            .value.filter((j) => j.fieldName == "addFeeBraces")[0].value;

          x.value[0].value = averagePricesDefault[0].value;
          x.value[1].value = averagePricesDefault[1].value;
          x.value[0].changed = false;
          x.value[1].changed = false;

          changedValues["addFeeBraces" + x.value[0].fieldName] = false;
          changedValues["addFeeBraces" + x.value[1].fieldName] = false;
        }
      });
    NumberOfCasesStore.setChanged(changedValues);

    this.setSelectedItem(selected);
    this.setConditons(c);
  }
  onChangePracticeProfileData(data) {
    var selected = { ...toJS(this.selectedItem) };
    selected.practiceProfile[0].value.forEach((x) => {
      if (x.fieldName == "clinicName") {
        x.value = data.clinicName;
      }

      if (x.fieldName == "speciality") {
        x.value = data.speciality;
      }
      if (x.fieldName == "doctorName") {
        x.value = data.doctorName;
      }
      if (x.fieldName == "adress") {
        x.value = data.adress;
      }
      if (x.fieldName == "email") {
        x.value = data.email;
      }
      if (x.fieldName == "openDays") {
        x.value = data.openDays;
      }

      if (x.fieldName == "numberClinics") {
        x.value = data.numberClinics;
      }

      if (x.fieldName == "products") {
        x.value[0].value = this.conditions.smileMate;
        x.value[2].value = this.conditions.monitoringAligners;
        x.value[3].value = this.conditions.monitoringBraces;
      }
      if (x.fieldName == "showHourly") {
        x.value = this.conditions.showHourly;
      }
      if (x.fieldName == "separateTeensAdults") {
        x.value = this.conditions.separateTeensAdults;
      }
      if (x.fieldName == "separateRole") {
        x.value = this.conditions.separateStaffRole;
      }
    });

    this.setSelectedItem(selected);
  }
  toUpdate(id, values) {
    this.selectedItem[id] = values;

    this.setNumbersToTest(this.selectedItem);
    if (id == "numberOfCases") {
      this.toUpdateOnDataChanged();
    }
  }

  toUpdateOnDataChanged() {
    var numbers = toJS(this.numbersToTest);
    const selected = { ...this.selectedItem };
    //workflowTreatment
    //alignersStatistics
    selected.workflowTreatement[0].value
      .filter((a) => a.fieldName == "alignersStatistics")[0]
      .value.forEach((x) => {
        if (x.fieldName == "averageDuration") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w24 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w25 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }
        if (x.fieldName == "appointmentsOverTreatment") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w24 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w25 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }
        if (x.fieldName == "appointementRefinement") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w24 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w25 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }

        if (x.fieldName == "emergencyAppointments") {
          x.value[0].display = numbers.w24 > 0 ? true : false;
          x.value[1].display =
            numbers.w25 > 0 && this.conditions.separateTeensAdults
              ? true
              : false;
        }
      });

    //workflowTreatment
    //bracesStatistics
    selected.workflowTreatement[0].value
      .filter((a) => a.fieldName == "bracesStatistics")[0]
      .value.forEach((x) => {
        if (x.fieldName == "bracesAverageDuration") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w28 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w29 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }
        if (x.fieldName == "bracesAppointmentsOverTreatment") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w28 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w29 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }

        if (x.fieldName == "bracesInaddition") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w28 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w29 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }
        if (x.fieldName == "relapse") {
          if (x.value[0].display != -1) {
            x.value[0].display = numbers.w28 > 0 ? true : false;
          }
          if (x.value[1].display != -1) {
            x.value[1].display =
              numbers.w29 > 0 && this.conditions.separateTeensAdults
                ? true
                : false;
          }
        }
      });
    WorkflowStore.setData(selected.workflowTreatement);

    this.setSelectedItem(selected);
  }
}

export default new ToolStore();
